export const getHelpHeroKey = () => process.env.REACT_APP_HELP_HERO_KEY;
export const isHelpHeroActive = Boolean(getHelpHeroKey());
